import type {TrimFeatureAssignmentInput} from '@dms/api/new-vehicle';

import type {AssignmentValues} from '../components/AssignmentDialog';
import {setTrimInclusion} from './setTrimInclusion';

export const updateTrimAssignmentSet = (
  assignments: TrimFeatureAssignmentInput[],
  featureId: string,
  values: AssignmentValues,
  canViewCost: boolean
): TrimFeatureAssignmentInput[] =>
  setTrimInclusion(assignments, featureId, values.inclusion, values.priceNet || null).map(
    (assignment) =>
      assignment.featureId === featureId
        ? {
            ...assignment,
            costNet: canViewCost ? values.costNet || null : assignment.costNet,
            sortOrder: values.sortOrder,
            appliesIf: {
              ...assignment.appliesIf,
              anyOfVariantIds: values.anyOfVariantIds,
              allOfFeatureIds: values.allOfFeatureIds,
            },
          }
        : assignment
  );
